import React from "react";
import { useZLBolt, useZLBoltOptions, useZLBoltStreamState } from "./ZLBolt";
export function useCamera() {
    const zlBolt = useZLBolt();
    const options = useZLBoltOptions();
    const state = useZLBoltStreamState();
    const [value, setValue] = React.useState((zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getCamera()) || (options === null || options === void 0 ? void 0 : options.setupCamera));
    React.useEffect(() => {
        setValue((zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getCamera()) || (options === null || options === void 0 ? void 0 : options.setupCamera));
        const handler = () => setValue(zlBolt.getCamera());
        zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.addEventListener("cameraChanged", handler);
        return () => zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.removeEventListener("cameraChanged", handler);
    }, [zlBolt, options, state]);
    return value;
}
export function useEnvironment() {
    const zlBolt = useZLBolt();
    const options = useZLBoltOptions();
    const state = useZLBoltStreamState();
    const [value, setValue] = React.useState((zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getEnvironment()) || (options === null || options === void 0 ? void 0 : options.setupEnvironment));
    React.useEffect(() => {
        setValue((zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getEnvironment()) || (options === null || options === void 0 ? void 0 : options.setupEnvironment));
        const handler = () => setValue(zlBolt.getEnvironment());
        zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.addEventListener("environmentChanged", handler);
        return () => zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.removeEventListener("environmentChanged", handler);
    }, [zlBolt, options, state]);
    return value;
}
export function usePRCodes() {
    const zlBolt = useZLBolt();
    const options = useZLBoltOptions();
    const state = useZLBoltStreamState();
    const [value, setValue] = React.useState((zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getPrCodes()) || (options === null || options === void 0 ? void 0 : options.setupPrCodes));
    React.useEffect(() => {
        setValue((zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getPrCodes()) || (options === null || options === void 0 ? void 0 : options.setupPrCodes));
        const handler = () => setValue(zlBolt.getPrCodes());
        zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.addEventListener("prcodesChanged", handler);
        return () => zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.removeEventListener("prcodesChanged", handler);
    }, [zlBolt, options, state]);
    return value;
}
export function useMode() {
    const zlBolt = useZLBolt();
    const options = useZLBoltOptions();
    const state = useZLBoltStreamState();
    const [value, setValue] = React.useState(zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getCurrentMode());
    React.useEffect(() => {
        setValue(zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.getCurrentMode());
        const handler = () => setValue(zlBolt.getCurrentMode());
        zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.addEventListener("modeChange", handler);
        return () => zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.removeEventListener("modeChange", handler);
    }, [zlBolt, options, state]);
    return value;
}
